import * as moment from 'moment';
import { DateTimeConverter } from 'src/app/core/services/mapper/converters';

export class CommissionRecours {
    static jsonMap = {
        id: 'id',
        dateDebut: { key: 'dateDebut', converter: new DateTimeConverter() },
        numero: 'numero'
    };

    id: number;
    dateDebut: moment.Moment;
    numero: string;
}
